import { render, staticRenderFns } from "./InvestPublic.vue?vue&type=template&id=a402ebc8&scoped=true&"
import script from "./InvestPublic.vue?vue&type=script&lang=js&"
export * from "./InvestPublic.vue?vue&type=script&lang=js&"
import style0 from "./InvestPublic.vue?vue&type=style&index=0&id=a402ebc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a402ebc8",
  null
  
)

export default component.exports